import {IframeHTMLAttributes, useRef} from 'react';
import useLazyLoad from '../hook/useLazyLoad';

interface IProps
  extends Omit<IframeHTMLAttributes<HTMLIFrameElement>, 'onError'> {
  isLazy?: boolean;
}

export default function PageIframe({
  src,
  width = '100%',
  height = '100%',
  isLazy = true,
  ...rest
}: IProps) {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const {canLoad, setIsError} = useLazyLoad<HTMLIFrameElement>(
    isLazy,
    iframeRef
  );

  return (
    <iframe
      width={width}
      height={height}
      frameBorder="0"
      src={canLoad ? src : undefined}
      ref={iframeRef}
      onError={() => setIsError(true)}
      {...rest}
    />
  );
}
